import { useState } from 'react';
import {
  InteractionsResponse,
  ProfileResponse,
  usePostInteractionsByTripByTripIdAndLinkSecretLikeMutation,
} from '../../store/backendApi';

interface LikeButtonProps {
  tripId: string;
  storyId: string;
  interactions: InteractionsResponse | undefined;
  linkSecret: string | null;
  profile?: ProfileResponse | null;
}

export const LikeButton = ({
  tripId,
  storyId,
  linkSecret,
  interactions,
  profile,
}: LikeButtonProps) => {
  const isLoggedIn = !!profile?.userId;

  const [showLoginNotification, setShowLoginNotification] = useState(false);
  const [postLike, { isLoading }] = usePostInteractionsByTripByTripIdAndLinkSecretLikeMutation();

  // Get likes for this story
  const story = interactions?.stories.find((st) => st.storyId === storyId);
  const likes = story?.likes || [];
  const likeCount = likes.length;
  const isLiked =
    isLoggedIn && profile?.userId ? likes.some((like) => like.userId === profile.userId) : false;

  const handleLike = async () => {
    if (!isLoggedIn) {
      setShowLoginNotification(true);
      setTimeout(() => setShowLoginNotification(false), 3000);
      return;
    }

    try {
      await postLike({
        tripId,
        linkSecret: linkSecret ?? 'none',
        likeBodyRequest: {
          storyId,
        },
      }).unwrap();
    } catch (error) {
      console.error('Failed to like story:', error);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={handleLike}
        disabled={isLoading}
        className={`flex items-center gap-1 px-3 py-2 text-sm rounded transition-colors ${
          isLiked
            ? 'bg-red-100 text-red-600 hover:bg-red-200'
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <svg
          className={`w-4 h-4 ${isLiked ? 'fill-current' : ''}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06
          1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
          />
        </svg>
        <span>{likeCount}</span>
      </button>

      {/* Login notification */}
      {showLoginNotification && (
        <div
          className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-3 py-2
        bg-gray-800 text-white text-xs rounded shadow-lg whitespace-nowrap z-10"
        >
          Please log in to like stories
          <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gray-800 rotate-45"></div>
        </div>
      )}
    </div>
  );
};
